import { createAsyncThunk } from "@reduxjs/toolkit";
import { updateVehicleCategoryMaster } from "../../../Api/api";
// Define an initial state for the slice
// const initialState = {
//    data: null,
//    loading: false,
//    error: null,
// };


export const updateCategoryMasterAsync=createAsyncThunk(
   "Tonnage/update",
   async ({ data, done, err }) => {
         try {
            const response = await updateVehicleCategoryMaster(data);
            done && done();
            return response.data;
         } catch (error) {
            // You can customize the error handling here
            
            err && err();
            throw error.response.data;
         }
      }

);




